// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import TitledCard from 'common/components/cards/TitledCard';
import type { RadioInformationFormSection, WebPlayerData } from '../../domain/RadioInformationForm';

type Props = {
  onChange: (value: RadioInformationFormSection) => mixed,
  data: WebPlayerData,
  t: any,
}

function WebPlayer(props: Props) {
  return (
    <div>
      <TitledCard title={props.t('doYouHaveAWebPlayer')}>
        <RadioButtonGroup
          name="hasWebPlayer"
          onChange={(e, v) => props.onChange({ ...props.data, hasWebPlayer: v })}
          defaultSelected={props.data.hasWebPlayer}
        >
          <RadioButton
            value
            label={props.t('yes')}
          />
          <RadioButton
            value={false}
            label={props.t('no')}
          />
        </RadioButtonGroup>
      </TitledCard>
      <TitledCard title={props.t('doesYourPlayerShowPlayingSong')}>
        <RadioButtonGroup
          name="webPlayerShowsPlayingSongs"
          onChange={(e, v) => props.onChange({ ...props.data, webPlayerShowsPlayingSongs: v })}
          defaultSelected={props.data.webPlayerShowsPlayingSongs}
        >
          <RadioButton
            value
            label={props.t('yes')}
          />
          <RadioButton
            value={false}
            label={props.t('no')}
          />
        </RadioButtonGroup>
      </TitledCard>
    </div>
  );
}

export default translate('radioConfiguration')(WebPlayer);



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/radioInformationForm/WebPlayer.js